import React from 'react';
import { photoUrl } from '../services/postService';
import { videoMimeType, videoPosterKey, videoWebKey } from '../utils/media';

type PostVideoProps = Omit<React.VideoHTMLAttributes<HTMLVideoElement>, 'src' | 'poster'> & {
  videoKey: string;
};

/**
 * A post/story video. Prefers the server-made H.264 MP4 (plays everywhere, smaller) and falls
 * back to the original upload, which is all there is while processing runs or for videos posted
 * before processing existed — a 404 on the first <source> just moves the browser to the next.
 * The poster is the same story: missing means the browser shows its usual first-frame/blank.
 */
const PostVideo = React.forwardRef<HTMLVideoElement, PostVideoProps>(({ videoKey, children, ...rest }, ref) => (
  <video ref={ref} poster={photoUrl(videoPosterKey(videoKey))} {...rest}>
    <source src={photoUrl(videoWebKey(videoKey))} type="video/mp4" />
    <source src={photoUrl(videoKey)} type={videoMimeType(videoKey)} />
    {children}
  </video>
));
PostVideo.displayName = 'PostVideo';

export default PostVideo;
